<template>
  <div class="accordion">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { provide, ref, watch } from 'vue'

const openItems = ref<string[]>([])

const toggleItem = (itemId: string) => {
  const index = openItems.value.indexOf(itemId)
  if (index === -1) {
    openItems.value.push(itemId)
  } else {
    openItems.value.splice(index, 1)
  }
}

provide('accordion', {
  openItems: openItems.value,
  toggleItem
})

watch(openItems, (newValue) => {
  provide('accordion', {
    openItems: newValue,
    toggleItem
  })
}, { deep: true })
</script> 